// Plans that include the Answer Engine but not Site Intelligence or the wider toolkit.
// Mirrors ANSWER_ENGINE_ONLY_TIERS in apps/subscriptions/middleware.py.
const ANSWER_ENGINE_ONLY_TIERS = ['starter'];

export const isAnswerEngineOnly = (user) => ANSWER_ENGINE_ONLY_TIERS.includes(user?.subscription_tier);
